/* jshint esversion: 6 */

import {PublisherCourse} from "publisher/PublisherCourse";
import {createScormApiForWbt} from "scorm/communication/createScormApiForWbt";
import {createApiForCustomizing} from "publisher/communication/createApiForCustomizing";
import {createProfileControllerApi} from "publisher/createProfileControllerApi";
import {Assert} from "common/Assert";

window.API = null

/**
 * Legacy behaviour:
 * The window.COURSE_DATA_API field is used to separate the wbt-sco -> publisher communication from the course-sco -> publisher
 * communication to keep both data sets in publisher. In order to that, on SCO launch, the sco.launch.jsp will check for
 * the window.API object and delegates it to the wbt as a scorm api. In case that window.api object is undefined, the
 * sco.launch.jsp will check for the presence of the TTKF-Publisher and instantiate a scorm api (PublisherScormApi.js) that connects the wbt
 * directly with the publisher.
 *
 * Refactoring for TTKF 20.1
 * This behaviour is now refactored and the publisher course api will provide as window.API and communicates with the player.
 * Unfortunately we can not remove the window.COURSE_DATA_API field, due to customer configurations will check this field to
 * assure that the course runs in a publisher scenario.
 *
 * @deprecated use window.API instead
 *
 * @type {object}
 */
window.COURSE_DATA_API = null;


export const PublisherCourseFactory = {

    // revealing public api
    createCourse: ( query, courseId, language, masteryScore ) => {

        Assert.checkArgument(query);
        Assert.checkArgument(courseId);
        Assert.checkArgument(language);

        const course = new PublisherCourse( query, courseId, language, masteryScore ),
            profileControllerApi = createProfileControllerApi( course );

        course.initialize();
        createApis();

        function createApis() {
            window.API = createScormApiForWbt( course );
            window.COURSE_DATA_API = createApiForCustomizing( course );
        }

        // revealing public api
        return {

            getClassName: () => "PublisherCourse",

            /**
             * Gets the storage system for the course.
             *
             * @returns {string} "tt_accelerator"
             */
            getStorageSystem: () => "tt_accelerator",

            /**
             * Gets the storage method for the course.
             *
             * @returns {string} "jsapi"
             */
            getStorageMethod: () => profileControllerApi.getStorageMethod(),

            /**
             * Gets the mastery score for the course.
             *
             * @returns {number} mastery score
             */
            getCourseMasteryScore: () => course.getMasteryScore(),

            /**
             * Due to the nature of the session based scorm communication
             * with the publisher, it is not allowed to start multiple
             * SCOs at the same time.
             *
             * @returns {boolean} false
             */
            isMultiScoLaunchAllowed: () => false,
            useScoLaunchParams: () => true,
            initScoreIDs: (useAssessments) => course.setScoreList(useAssessments),
            prepareSequenceLaunch: (scoId) => course.initializeActiveLearningSco(scoId),
            isSequenceConnected: () => course.hasActiveLearningSco(),

            /**
             * The current status will be committed to the publisher.
             */
            terminate: () => course.commit(),

            /**
             * @deprecated
             *
             * @return {Boolean} false
             */
            handleBrowserOnTerminate: () => false,

            onSequenceTerminate: () => {},

            /**
             * DOM synchronization
             */

            getProfileController: () => profileControllerApi,
            setUsername: ( name ) => profileControllerApi.setUsername( name ),
            getUsername: () => profileControllerApi.getUsername(),

            initSequenceData: course.domStructure.initSequenceData,
            getSequenceData: course.domStructure.getSequenceData,
            setSequenceData: course.domStructure.setSequenceData,
            getSequenceDataMap: course.domStructure.getSequenceDataMap,
            clearSequenceDataMap: course.domStructure.clearSequenceDataMap,
            getSequenceInfos: course.domStructure.getSequenceInfos,
            getScoreIDs: course.domStructure.getScoreIDs,
            getResultMap: course.domStructure.getResultMap,

            refreshStatus: () => course.onDomAndModelSynchronized()
        };
    }
}
